// API Endpoints
// 실제 배포 시 환경변수 또는 아래 URL을 실제 서버 주소로 교체하세요.
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3001/api";
// 예시: export const API_BASE_URL = 'https://api.goldttack.com/api';

// Routes
export const ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  SERVICES: "/services",
  CONTACT: "/contact",
  LOGIN: "/login",
  REGISTER: "/register",
};

// Local Storage Keys
export const STORAGE_KEYS = {
  USER_TOKEN: "user_token",
  USER_DATA: "user_data",
  THEME: "theme",
  LANGUAGE: "language",
};

// Theme
export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
};

// Languages
export const LANGUAGES = {
  EN: "en",
  KO: "ko",
  JA: "ja",
};

// Validation Rules
export const VALIDATION_RULES = {
  PASSWORD_MIN_LENGTH: 8,
  USERNAME_MIN_LENGTH: 3,
  USERNAME_MAX_LENGTH: 20,
  EMAIL_MAX_LENGTH: 254,
};

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
};

// File Upload
export const FILE_UPLOAD = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_TYPES: ["image/jpeg", "image/png", "image/gif", "application/pdf"],
};

// Error Messages
export const ERROR_MESSAGES = {
  REQUIRED_FIELD: "This field is required",
  INVALID_EMAIL: "Please enter a valid email address",
  PASSWORD_TOO_SHORT: `Password must be at least ${VALIDATION_RULES.PASSWORD_MIN_LENGTH} characters`,
  USERNAME_TOO_SHORT: `Username must be at least ${VALIDATION_RULES.USERNAME_MIN_LENGTH} characters`,
  USERNAME_TOO_LONG: `Username must be no more than ${VALIDATION_RULES.USERNAME_MAX_LENGTH} characters`,
  FILE_TOO_LARGE: "File size must be less than 5MB",
  INVALID_FILE_TYPE: "Invalid file type",
  NETWORK_ERROR: "Network error. Please try again.",
  SERVER_ERROR: "Server error. Please try again later.",
};

// Success Messages
export const SUCCESS_MESSAGES = {
  PROFILE_UPDATED: "Profile updated successfully",
  PASSWORD_CHANGED: "Password changed successfully",
  EMAIL_SENT: "Email sent successfully",
  DATA_SAVED: "Data saved successfully",
  ITEM_DELETED: "Item deleted successfully",
};

// Colors
export const COLORS = {
  blue500: "rgba(17, 124, 228, 1)", // #117CE4
};
